/**
 * Shared Socket.IO client (cookies + userType match backend socketAuth).
 * Reuses one connection per tab; join to school room is handled server-side on connect.
 */
import { io } from "socket.io-client";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

/** @type {import("socket.io-client").Socket | null} */
let socket = null;
let currentUserType = null;

/**
 * @param {"owner"|"staff"} userType
 */
export function getSocket(userType = "owner") {
  const type = userType === "staff" ? "staff" : "owner";

  if (socket && currentUserType === type) {
    if (!socket.connected) socket.connect();
    return socket;
  }

  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }

  currentUserType = type;
  socket = io(API, {
    withCredentials: true,
    auth: { userType: type },
    query: { userType: type },
    transports: ["websocket", "polling"],
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
  });

  socket.on("connect_error", (err) => {
    console.warn("[socket] connect_error:", err?.message || err);
  });

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
    currentUserType = null;
  }
}

export default getSocket;
